export default (state, action) => {
  return Object.assign({}, state, { loading: false });
};
